export default "__VITE_ASSET__CwHyd3Ra__"